import React from "react";
import { Empty } from "antd";

// Fully reusable Antd Empty component
const CustomEmpty = ({
  description = "No Data",
  image = Empty.PRESENTED_IMAGE_SIMPLE,
  children,
  ...rest
}) => (
  <Empty description={description} image={image} {...rest}>
    {children}
  </Empty>
);

export default CustomEmpty;
